/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * HyusnSu Sim (hssim@rsupport.com)
 *
 * @description
 *
 * @created at Fri Apr 23 2023
 **/

import { css } from "@emotion/react";

import { ZIndex } from "@/frameworks/core/commons";

import { ModalProps } from "../Modal";

export const ModalPosition = () => css`
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
`;

export const ModalBackdropPosition = (zIndex?: number) => css`
	position: fixed;
	opacity: 0;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	animation: show 250ms cubic-bezier(0.38, 0.97, 0.56, 0.76) forwards;
	@keyframes show {
		100% {
			opacity: 1;
		}
	}
	background-color: rgba(0, 0, 0, 0.4);
	z-index: ${zIndex ? zIndex : ZIndex.POPUP};
`;

export const ModalBody = (
	width: ModalProps["width"],
	height: ModalProps["height"],
	radius: ModalProps["radius"] = "10px"
) => css`
	width: ${width};
	height: ${height};
	text-align: center;
	background-color: rgb(255, 255, 255);
	border-radius: ${radius};
	box-shadow: 0 2px 3px 0 rgba(34, 36, 38, 0.15);
`;

export const ModalClose = css`
	padding: 5px;
	position: absolute;
	top: 15px;
	right: 15px;
	width: 30px;
	height: 30px;
	border: none;
	color: rgba(0, 0, 0, 0.7);
	background-color: transparent;
	font-size: 20px;
	line-height: 1;

	&:hover {
		animation: rotate 250ms cubic-bezier(0.38, 0.97, 0.56, 0.76) forwards;
	}

	cursor: pointer;
	@keyframes rotate {
		100% {
			transform: rotateZ(180deg);
		}
	}
`;
